import { Injectable } from "@angular/core";
import { DomainInfo } from "@app/shared/models/DomainInfo";
import { UrlInfo } from "@app/shared/models/url-info";
import { SharedService } from "../shared/shared.service";

@Injectable({
  providedIn: "root",
})
export class QrService {
  constructor(private sharedService: SharedService) {}
  splitQrUrl(url: string): UrlInfo {
    const qrresponse = url.split("?domainname=");
    const part2 = qrresponse[1].split("&");

    const domainname = part2[0];
    const location = part2[1]?.split("=")[1];
    const device_id = part2[2]?.split("=")[1];
    const locationId = "";
    let urlInfo: UrlInfo;
    urlInfo = {
      domainname,
      location,
      device_id,
      locationId,
    };
    return urlInfo;
  }

  async goBackToJobDetails(data: DomainInfo, urlInfo: UrlInfo) {
    const { DomainName, _id } = data.customerData;
    const location = data.customerData.CustomerName;
    this.sharedService.tempCustomerDetails = data;
    this.sharedService.tempDomainInfo = {
      domainname: DomainName,
      location: location,
      device_id: urlInfo.device_id,
      locationId: urlInfo.location,
      customerId: _id,
    };
    return null;
  }
}
